<div class="filter-header">
	@if (PermissionService.hasPermission('access_request')) {
		<div class="filter-container frow">
			<div class="date-filter-container">
				<div
					class="button"
					[ngClass]="{ active: this.selectedValues.period_type === 'today' }"
					(click)="this.selectedValues.period_type = 'today'">
					{{ this.labels.lbl_geral_dia }}
				</div>
				<div
					class="button"
					[ngClass]="{ active: this.selectedValues.period_type === 'week' }"
					(click)="this.selectedValues.period_type = 'week'">
					{{ this.labels.lbl_geral_semana }}
				</div>
				<div
					class="button"
					[ngClass]="{ active: this.selectedValues.period_type === 'month' }"
					(click)="this.selectedValues.period_type = 'month'">
					{{ this.labels.lbl_geral_mes }}
				</div>
			</div>
			<div class="icon-container" [ngClass]="{ active: this.selectedValues.period_type === 'custom' }">
				<fa-icon [icon]="icons.faCalendar" (click)="openDatePicker()"></fa-icon>
				@if (isDatePickerOpen === true) {
					<div class="date-picker-wrapper">
						<date-range-picker
							[showTime]="false"
							(datesConfirmed)="selectDate($event)"
							(calendarClosed)="isDatePickerOpen = false">
						</date-range-picker>
					</div>
				}
			</div>
		</div>
	}

	<div class="filter-group">
		<div class="filter-container">
			<span class="ci-label"> {{ this.labels.lbl_asset_tipo_ci }}</span>
			<div class="custom-select-wrapper">
				<cpi-dot-bounce-loading-effect [color]="'var(--const-black)'" *ngIf="isLoadingCiTypes"></cpi-dot-bounce-loading-effect>
				<ng-container *ngIf="!isLoadingCiTypes">
					<msp-multi-checkbox-select
						[options]="getCiTypeOptions()"
						[allLabel]="this.labels.lbl_geral_todos"
						[selectedLabel]="this.labels.lbl_geral_selecionados"
						(selectedValuesChange)="handleCiTypeSelectionChange($event)">
					</msp-multi-checkbox-select>
				</ng-container>
			</div>
		</div>

		<div class="filter-container">
			<span class="ci-label"> {{ this.labels.lbl_localidade }}</span>
			<div class="custom-select-wrapper">
				<cpi-dot-bounce-loading-effect [color]="'var(--const-black)'" *ngIf="isLoadingLocations"></cpi-dot-bounce-loading-effect>
				<ng-container *ngIf="!isLoadingLocations">
					<div class="filter-select custom-select-trigger" (click)="toggleLocationDropdown($event)">
						<span>{{ getLocationSelectionLabel() }}</span>
						<span class="dropdown-arrow">▼</span>
					</div>
					<div class="custom-dropdown" *ngIf="isLocationDropdownOpen && !isLoadingLocations">
						<div class="dropdown-option" (click)="selectAllLocations(); $event.stopPropagation()">
							<span>{{ this.labels.lbl_geral_todos }}</span>
							<input
								type="checkbox"
								class="checkbox-color"
								[checked]="isAllLocationsSelected()"
								(click)="$event.stopPropagation()" />
						</div>
						<div
							class="dropdown-option"
							*ngFor="let location of availableLocations"
							(click)="toggleLocationSelection(location.id_location); $event.stopPropagation()">
							<span>{{ location.site }} - {{ location.location }}</span>
							<input
								type="checkbox"
								class="checkbox-color"
								[checked]="isLocationSelected(location.id_location)"
								(click)="$event.stopPropagation()" />
						</div>
					</div>
				</ng-container>
			</div>
		</div>

		<div class="filter-container">
			<span class="ci-label">{{ labels.lbl_status_ci }}</span>
			<div class="custom-select-wrapper">
				<cpi-dot-bounce-loading-effect [color]="'var(--const-black)'" *ngIf="isLoadingStatuses"></cpi-dot-bounce-loading-effect>
				<ng-container *ngIf="!isLoadingStatuses">
					<div class="filter-select custom-select-trigger" (click)="toggleStatusDropdown($event)">
						<span>{{ getStatusSelectionLabel() }}</span>
						<span class="dropdown-arrow">▼</span>
					</div>
					<div class="custom-dropdown" *ngIf="isStatusDropdownOpen">
						<div class="dropdown-option" (click)="selectAllStatuses(); $event.stopPropagation()">
							<span>{{ this.labels.lbl_geral_todos }}</span>
							<input
								type="checkbox"
								class="checkbox-color"
								[checked]="isAllStatusesSelected()"
								(click)="$event.stopPropagation()" />
						</div>
						<div
							class="dropdown-option"
							*ngFor="let status of availableStatus"
							(click)="toggleStatusSelection(status.id.toString()); $event.stopPropagation()">
							<span>{{ status.status }}</span>
							<input
								type="checkbox"
								class="checkbox-color"
								[checked]="isStatusSelected(status.id.toString())"
								(click)="$event.stopPropagation()" />
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div class="button-container">
		<msp-button (click)="filterValues()">{{ labels.lbl_geral_filtrar }}</msp-button>
		<msp-button (click)="clearFilters()">{{ labels.lbl_limpar_filtros }}</msp-button>
	</div>
</div>
